import React, { useState, useEffect } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import assetPath from 'venuescanner-js/constants/asset_path';

const CarouselImage = ({
  isMain,
  isActive,
  src,
  alt,
  spaceHash,
  style = {},
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isActive && !isLoaded) setIsLoaded(true);
  }, [isLoaded, isActive, setIsLoaded]);

  useEffect(() => {
    if (isLoaded && spaceHash) {
      window.dataLayer.push({
        event: 'SPACE_IMPR',
        event_category: 'Impression',
        event_action: 'space_tile',
        event_label: spaceHash,
      });
    }
  }, [isLoaded, spaceHash]);

  return (
    <div className='space-tile__viewport__image' style={style}>
      {isLoaded ? (
        <img
          className={cl({
            'viewport__image--loading': isLoading,
            mainImage: isMain,
          })}
          onLoad={() => {
            setIsLoading(false);
          }}
          src={assetPath(src)}
          alt={alt}
        />
      ) : (
        isMain && (
          <noscript>
            <img
              className={cl({ mainImage: isMain })}
              itemProp='image'
              src={assetPath(src)}
              alt={alt}
            />
          </noscript>
        )
      )}
    </div>
  );
};

CarouselImage.propTypes = {
  isMain: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  spaceHash: PropTypes.string,
  style: PropTypes.object,
};

export default CarouselImage;
